var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 11.7295V1.72949",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4944 15.1628L8.32773 11.7295H3.4694C3.21066 11.7295 2.95547 11.6693 2.72405 11.5535C2.49262 11.4378 2.29131 11.2698 2.13607 11.0628C1.98082 10.8558 1.8759 10.6155 1.82962 10.361C1.78333 10.1064 1.79695 9.84455 1.8694 9.59616L3.81107 2.92949C3.91204 2.5833 4.12257 2.2792 4.41107 2.06283C4.69956 1.84646 5.05045 1.72949 5.41107 1.72949H16.6611C17.1031 1.72949 17.527 1.90509 17.8396 2.21765C18.1521 2.53021 18.3277 2.95413 18.3277 3.39616V10.0628C18.3277 10.5049 18.1521 10.9288 17.8396 11.2413C17.527 11.5539 17.1031 11.7295 16.6611 11.7295H14.3611C14.051 11.7297 13.7471 11.8163 13.4836 11.9797C13.2201 12.1431 13.0074 12.3768 12.8694 12.6545L9.9944 18.3962C9.60142 18.3913 9.21462 18.2977 8.8629 18.1223C8.51118 17.947 8.20363 17.6944 7.96323 17.3835C7.72283 17.0726 7.5558 16.7114 7.47462 16.3268C7.39344 15.9423 7.4002 15.5444 7.4944 15.1628Z",
    stroke: "#333333",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbdownIcon);
export default __webpack_public_path__ + "static/media/thumbdown-icon.648be2059d77017f0065709ebd0f409c.svg";
export { ForwardRef as ReactComponent };